import * as sortDirections from "../enums/sortDirections";
import find from "lodash.find";

function getSortOrder(fieldNames, fields) {
	return Object.keys(fields)
		.map(key => fields[key])
		.filter(
			f =>
				f.sort !== null &&
				f.sort !== undefined &&
				find(fieldNames, name => f.name === name),
		)
		.sort((f1, f2) => f1.sort - f2.sort)
		.slice(0, 3)
		.map(f => {
			if (f.ascending) {
				return `${f.name} ${sortDirections.ASC}`;
			}
			return `${f.name} ${sortDirections.DESC}`;
		});
}

export default function getSearchSortOrder(fieldNames, fields, tabSortOrder) {
	if (tabSortOrder) {
		const order = tabSortOrder.filter(sortColumn =>
			find(fieldNames, name => sortColumn.split(" ")[0] === name),
		);
		if (order.length > 0) {
			return order;
		}
	}

	return getSortOrder(fieldNames, fields);
}
